"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachmentValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
exports.attachmentValidationSchema = (0, yup_1.object)().shape({
    title: yup_rules_1.titleValidationSchema,
    url: (0, yup_1.string)().required("form.validations.valueMissing"),
});
//# sourceMappingURL=index.js.map